import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import useFetchData from "../../../../hooks/useFetchData";
import { Button, SelectBox, SelectBoxItem } from "../../../../components";
import { Link, useLocation } from "react-router-dom";
import { SearchBlack } from "../../../../components/Icons/Icons";
import { useCallback, useEffect, useState } from "react";
import axiosClient from "../../../../services/axiosClient";
import { defaultCompanyFill, normalCompanyFill } from "./configFillter";
import { useStoreContext } from "../../../../hooks/useStoreContext";

const cx = classNames.bind(styles);

function Filter({
  input,
  onChangeTextSearch,
  onChangeAddress,
  onChangeStatus,
  // onChangeGroup,
  // onChangeService,
  onChangeCompany
}) {
  const companyCode = sessionStorage.getItem('company_code');
  const [listCompany, setListCompany] = useState([]);
  const [dataStore, dispatch] = useStoreContext();
  const listFillter = dataStore.filterCamera;
  const { state } = useLocation();
  const province = useFetchData("province/get-info-province/", {
    nation_code: "VNM",
  });
  const filter = companyCode === 'DEFAULT' ? defaultCompanyFill : normalCompanyFill;
  // const groupCamera = useFetchData("/groupCam/get-list-groupCam/");
  // const service = useFetchData("/service/get-list-services/");
  const getListCompany = useCallback(async () => {
    try {
      const res = await axiosClient.get('/company/get-list-company/')
      setListCompany(res?.data)
    } catch (error) {

    }
  }, [])

  useEffect(() => {
    if (companyCode === 'DEFAULT') {
      getListCompany()
    }
  }, [companyCode, getListCompany])
  return (
    <>
      <div className={cx("filter")}>
        <div className={cx("fill-control")}>
          {companyCode === 'DEFAULT' && (
            <div className={cx("search")}>
              <input
                value={input}
                onChange={onChangeTextSearch}
                className={cx("search-input")}
                placeholder="Tìm kiếm..."
                maxLength={155}
              />
              <span className={cx("icon-search")}>
                <SearchBlack />
              </span>
            </div>
          )}
          {listCompany.length > 0 ? (
            <div>
              <label className={cx("label")}>Công ty</label>
              <SelectBox
                style={{ paddingTop: 8 }}
                type="small"
                className={cx("select")}
                onChange={onChangeCompany}
                values={listCompany.length > 0 &&
                  listCompany.find(item => item.CODE === listFillter.company) ?
                  listCompany.find(item => item.CODE === listFillter.company).NAME :
                  null
                }
              >
                <SelectBoxItem label="Tất cả" value="all" />
                {listCompany.length > 0 &&
                  listCompany.map((item, index) => (
                    <SelectBoxItem
                      label={item.NAME}
                      value={item.CODE}
                      key={index}
                    />
                  ))}
              </SelectBox>
            </div>
          ) : (
            <div className={cx("search")}>
              <input
                value={input}
                onChange={onChangeTextSearch}
                className={cx("search-input")}
                placeholder="Tìm kiếm..."
              />
              <span className={cx("icon-search")}>
                <SearchBlack />
              </span>
            </div>
          )}
          <div>
            <label className={cx("label")}>Địa điểm</label>
            <SelectBox
              style={{ paddingTop: 8 }}
              type="small"
              className={cx("select")}
              onChange={onChangeAddress}
              values={province.data &&
                province.data.find(item => item.PROVINCE_CODE === listFillter.address) ?
                province.data.find(item => item.PROVINCE_CODE === listFillter.address).PROVINCE_NAME :
                null
              }
            >
              <SelectBoxItem label="Tất cả" value="all" />
              {province.data &&
                province.data.map((item, index) => (
                  <SelectBoxItem
                    label={item.PROVINCE_NAME}
                    value={item.PROVINCE_CODE}
                    key={index}
                  />
                ))}
            </SelectBox>
          </div>
          <div>
            <label className={cx("label")}>Trạng thái</label>
            <SelectBox
              style={{ paddingTop: 8 }}
              type="small"
              className={cx("select")}
              onChange={onChangeStatus}
              values={(!state || state === 'all')
                ? (
                  filter.find(item => item.value === listFillter.status) ? filter.find(item => item.value === listFillter.status).label : null
                )
                : state === '0'
                  ? 'Đang trực tuyến'
                  : state === 1
                    ? 'Mất kết nối'
                    : 'Sẵn sàng'}
            >
              <SelectBoxItem label="Tất cả" value="all" />
              {filter.map(item => {
                return (
                  <SelectBoxItem key={item.value} label={item.label} value={item.value} />
                )
              })}
            </SelectBox>
          </div>
        </div>
        <div>
          <Link
            to="/admin/camera/add_camera"
            style={{ textDecoration: "none" }}
          >
            <Button
              className={cx("btn")}
              title="Thêm mới camera"
              onClick={() => {
                return 0;
              }}
            />
          </Link>
        </div>
      </div>
    </>
  );
}

export default Filter;
